import React from "react";

import { TextDoc } from "src/common/components/TextDoc";

export const DummyToc: React.FunctionComponent = () => (
	<TextDoc>
		<section>
			<p>
				Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
				eiusmod tempor incididunt ut labore et dolore magna aliqua.
				Tristique sollicitudin nibh sit amet commodo. Eros donec ac odio
				tempor orci dapibus ultrices. Turpis massa tincidunt dui ut
				ornare lectus sit. Pretium vulputate sapien nec sagittis aliquam
				malesuada bibendum arcu. Nisl condimentum id venenatis a
				condimentum vitae sapien pellentesque. Pellentesque eu tincidunt
				tortor aliquam nulla facilisi. Egestas egestas fringilla
				phasellus faucibus scelerisque eleifend. Facilisi etiam
				dignissim diam quis enim lobortis scelerisque fermentum. Nisi
				porta lorem mollis aliquam. A iaculis at erat pellentesque.
				Dignissim suspendisse in est ante in. Viverra nibh cras pulvinar
				mattis. At auctor urna nunc id cursus metus. Purus in mollis
				nunc sed.
			</p>
			<p>
				Sapien nec sagittis aliquam malesuada bibendum arcu vitae
				elementum. Eget velit aliquet sagittis id consectetur purus ut
				faucibus pulvinar. Scelerisque purus semper eget duis.
				Ullamcorper velit sed ullamcorper morbi tincidunt.
			</p>
		</section>
		<section>
			<p>
				Ultrices tincidunt arcu non sodales neque sodales ut etiam sit.
				Diam vel quam elementum pulvinar etiam non quam. Adipiscing
				bibendum est ultricies integer quis auctor elit. Turpis cursus
				in hac habitasse. At imperdiet dui accumsan sit. Phasellus
				egestas tellus rutrum tellus pellentesque eu tincidunt tortor.
				Sit amet justo donec enim diam vulputate. Varius sit amet mattis
				vulputate. Ut tellus elementum sagittis vitae et leo duis. Vitae
				turpis massa sed elementum tempus egestas. Adipiscing enim eu
				turpis egestas pretium aenean. Cras fermentum odio eu feugiat
				pretium nibh ipsum consequat nisl. Lacus vel facilisis volutpat
				est. Fames ac turpis egestas integer eget aliquet. Sollicitudin
				nibh sit amet commodo. Aliquam ut porttitor leo a diam
				sollicitudin tempor id. Urna et pharetra pharetra massa. Viverra
				ipsum nunc aliquet bibendum. Posuere morbi leo urna molestie at
				elementum eu facilisis.
			</p>
		</section>
		<section>
			<p>
				Purus sit amet volutpat consequat mauris nunc congue nisi.
				Commodo odio aenean sed adipiscing diam donec adipiscing
				tristique risus. Purus sit amet volutpat consequat. Ac feugiat
				sed lectus vestibulum mattis ullamcorper velit sed. Vulputate mi
				sit amet mauris. Mi in nulla posuere sollicitudin aliquam
				ultrices sagittis orci. Quisque egestas diam in arcu cursus
				euismod quis. Sed vulputate odio ut enim blandit volutpat.
				Pulvinar etiam non quam lacus suspendisse. Ultrices in iaculis
				nunc sed.
			</p>
			<p>
				Dolor sit amet consectetur adipiscing. Amet nulla facilisi morbi
				tempus iaculis urna id volutpat lacus. Vitae aliquet nec
				ullamcorper sit amet risus. Nec feugiat in fermentum posuere
				urna. Tellus pellentesque eu tincidunt tortor aliquam. Tellus id
				interdum velit laoreet id donec. Nulla facilisi cras fermentum
				odio. Suspendisse ultrices gravida dictum fusce ut placerat
				orci. Metus dictum at tempor commodo ullamcorper a lacus.
				Consequat semper viverra nam libero justo laoreet. Arcu ac
				tortor dignissim convallis aenean et tortor. Proin fermentum leo
				vel orci porta non pulvinar. Amet nisl purus in mollis. Cras
				semper auctor neque vitae tempus quam pellentesque. Elit
				ullamcorper dignissim cras tincidunt. Eu ultrices vitae auctor
				eu augue ut. Orci ac auctor augue mauris augue neque. Tortor
				consequat id porta nibh venenatis cras sed felis eget. Etiam
				erat velit scelerisque in dictum non consectetur a.
			</p>
			<p>
				Nunc scelerisque viverra mauris in. Duis tristique sollicitudin
				nibh sit. Tincidunt dui ut ornare lectus sit amet est. Sed risus
				pretium quam vulputate dignissim suspendisse in est ante.
				Pharetra diam sit amet nisl suscipit adipiscing bibendum est.
				Ultrices vitae auctor eu augue ut lectus. Imperdiet proin
				fermentum leo vel. Nibh sit amet commodo nulla facilisi.
				Parturient montes nascetur ridiculus mus mauris vitae ultricies
				leo integer. Diam quis enim lobortis scelerisque. Imperdiet sed
				euismod nisi porta lorem.
			</p>
		</section>
		<section>
			<p>
				Ultrices tincidunt arcu non sodales neque sodales ut etiam sit.
				Diam vel quam elementum pulvinar etiam non quam. Adipiscing
				bibendum est ultricies integer quis auctor elit. Turpis cursus
				in hac habitasse. At imperdiet dui accumsan sit. Phasellus
				egestas tellus rutrum tellus pellentesque eu tincidunt tortor.
				Sit amet justo donec enim diam vulputate. Varius sit amet mattis
				vulputate. Ut tellus elementum sagittis vitae et leo duis. Vitae
				turpis massa sed elementum tempus egestas. Adipiscing enim eu
				turpis egestas pretium aenean. Cras fermentum odio eu feugiat
				pretium nibh ipsum consequat nisl. Lacus vel facilisis volutpat
				est. Fames ac turpis egestas integer eget aliquet. Sollicitudin
				nibh sit amet commodo. Aliquam ut porttitor leo a diam
				sollicitudin tempor id. Urna et pharetra pharetra massa. Viverra
				ipsum nunc aliquet bibendum. Posuere morbi leo urna molestie at
				elementum eu facilisis.
			</p>
		</section>
		<section>
			<p>
				Purus sit amet volutpat consequat mauris nunc congue nisi.
				Commodo odio aenean sed adipiscing diam donec adipiscing
				tristique risus. Purus sit amet volutpat consequat. Ac feugiat
				sed lectus vestibulum mattis ullamcorper velit sed. Vulputate mi
				sit amet mauris. Mi in nulla posuere sollicitudin aliquam
				ultrices sagittis orci. Quisque egestas diam in arcu cursus
				euismod quis. Sed vulputate odio ut enim blandit volutpat.
				Pulvinar etiam non quam lacus suspendisse. Ultrices in iaculis
				nunc sed.
			</p>
			<p>
				Dolor sit amet consectetur adipiscing. Amet nulla facilisi morbi
				tempus iaculis urna id volutpat lacus. Vitae aliquet nec
				ullamcorper sit amet risus. Nec feugiat in fermentum posuere
				urna. Tellus pellentesque eu tincidunt tortor aliquam. Tellus id
				interdum velit laoreet id donec. Nulla facilisi cras fermentum
				odio. Suspendisse ultrices gravida dictum fusce ut placerat
				orci. Metus dictum at tempor commodo ullamcorper a lacus.
				Consequat semper viverra nam libero justo laoreet. Arcu ac
				tortor dignissim convallis aenean et tortor. Proin fermentum leo
				vel orci porta non pulvinar. Amet nisl purus in mollis. Cras
				semper auctor neque vitae tempus quam pellentesque. Elit
				ullamcorper dignissim cras tincidunt. Eu ultrices vitae auctor
				eu augue ut. Orci ac auctor augue mauris augue neque. Tortor
				consequat id porta nibh venenatis cras sed felis eget. Etiam
				erat velit scelerisque in dictum non consectetur a.
			</p>
			<p>
				Nunc scelerisque viverra mauris in. Duis tristique sollicitudin
				nibh sit. Tincidunt dui ut ornare lectus sit amet est. Sed risus
				pretium quam vulputate dignissim suspendisse in est ante.
				Pharetra diam sit amet nisl suscipit adipiscing bibendum est.
				Ultrices vitae auctor eu augue ut lectus. Imperdiet proin
				fermentum leo vel. Nibh sit amet commodo nulla facilisi.
				Parturient montes nascetur ridiculus mus mauris vitae ultricies
				leo integer. Diam quis enim lobortis scelerisque. Imperdiet sed
				euismod nisi porta lorem.
			</p>
		</section>
	</TextDoc>
);
